import type { HTMLAttributes } from "react";
import { cn } from "@/shared/cn";

type KickerTone = "faint" | "withdrawal";

export interface KickerProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: KickerTone;
}

export function Kicker({ tone = "faint", className, children, ...rest }: KickerProps) {
  return (
    <span
      className={cn(
        "inline-block font-(family-name:--font-mono) font-semibold text-xs leading-none uppercase tracking-[0.55px]",
        TONE_CLASSES[tone],
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  );
}

const TONE_CLASSES: Record<KickerTone, string> = {
  faint: "text-[var(--color-text-faint)]",
  withdrawal: "text-[var(--color-withdrawal)]",
};
